module.exports = __webpack_public_path__ + "static/img/b-cms-logo.23f8aea.png";